<template>
    <v-navigation-drawer
            class="menu-lateral"
            style="background-color:#1d4ed8"
            dark
            app
            :width="320"
            v-model="localDrawer"
            :expand-on-hover="false"
            :right="false"
    >
        <v-list dense>
            <!-- Logo e Nome da Empresa -->
            <v-list-item class="company-branding">
                <v-list-item-avatar>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 1920 1080" 
                        width="48" 
                        height="27"
                    >
                        <path fill="#ffffff" d="M1506.29,836.18c-59.15,0-107.1,51.14-107.1,114.24h214.2c0-63.09-47.95-114.24-107.1-114.24Z"/>
                        <polygon fill="#ffffff" points="188.54 553.44 233.36 401.52 277.85 553.44 334.37 553.44 390.87 321.5 332.74 321.5 298.64 473.1 258.69 321.5 208.03 321.5 167.76 473.1 133.66 321.5 75.53 321.5 132.04 553.44 188.54 553.44"/>
                        <path fill="#ffffff" d="M429.27,534.68c8.01,8.34,18.4,14.28,31.18,17.82,12.99,3.54,28.69,5.31,47.09,5.31s34.32-1.77,47.09-5.31c12.77-3.54,23.16-9.48,31.18-17.82,8.01-8.54,13.75-20.01,17.21-34.38,3.46-14.59,5.2-32.82,5.2-54.7s-1.74-40.32-5.2-54.7c-3.47-14.38-9.2-25.74-17.21-34.07-8.01-8.54-18.4-14.59-31.18-18.13-12.78-3.54-28.47-5.31-47.09-5.31s-34.1,1.77-47.09,5.31c-12.78,3.54-23.17,9.59-31.18,18.13-8.01,8.34-13.75,19.69-17.21,34.07-3.46,14.38-5.2,32.61-5.2,54.7s1.74,40.12,5.2,54.7c3.47,14.38,9.2,25.84,17.21,34.38ZM474.08,404.02c2.16-9.79,5.85-16.57,11.04-20.32,5.41-3.75,12.88-5.63,22.41-5.63s16.89,1.88,22.08,5.63c5.41,3.75,9.09,10.52,11.04,20.32,2.16,9.79,3.24,23.65,3.24,41.57s-1.08,31.78-3.24,41.57c-1.95,9.79-5.63,16.57-11.04,20.32-5.2,3.75-12.56,5.63-22.08,5.63s-17-1.88-22.41-5.63c-5.2-3.75-8.88-10.52-11.04-20.32-2.16-9.79-3.25-23.65-3.25-41.57s1.08-31.78,3.25-41.57Z"/>
                        <path fill="#ffffff" d="M749.89,488.73l15.91,64.71h63.98l-18.52-66.58c-1.73-8.13-4.65-14.48-8.77-19.07-3.9-4.79-8.23-8.23-12.99-10.32-4.55-2.08-8.88-3.34-12.99-3.75v-1.88c11.26-1.25,20.14-4.17,26.63-8.75,6.5-4.79,11.04-10.94,13.64-18.44,2.81-7.5,4.22-15.84,4.22-25.01,0-16.88-3.14-29.91-9.42-39.07-6.06-9.38-15.7-16.05-28.9-20.01-13.21-3.96-30.31-5.94-51.32-5.94-14.07,0-26.2.1-36.37.31-9.96,0-19.16.21-27.61.62-8.44.42-17.43,1.15-26.96,2.19v215.69h59.76v-81.55c8.14.04,17.56.14,28.26.28,6.28,0,11.04,1.15,14.29,3.44,3.25,2.08,5.63,6.46,7.15,13.13ZM700.2,429.65v-52.44c9.14-.05,19.1-.08,29.88-.08,7.79,0,13.75.73,17.86,2.19,4.33,1.46,7.36,4.06,9.09,7.81,1.73,3.75,2.6,9.17,2.6,16.25s-.87,12.29-2.6,16.25c-1.74,3.75-4.76,6.36-9.09,7.81-4.11,1.46-10.07,2.19-17.86,2.19h-29.88Z"/>
                        <path fill="#ffffff" d="M916.85,395.27v-57.52h-60.73v215.69h60.73v-72.21c0-6.04-.86-12.71-2.6-20.01-.03-.1-.05-.21-.07-.31h16.14l52.46,92.53h67.55l-55.86-91.28c-2.38-4.38-5.63-8.34-9.75-11.88-4.11-3.75-7.69-6.46-10.72-8.13v-.94c3.03-1.66,6.17-3.96,9.42-6.88,3.25-3.13,6.17-6.77,8.77-10.94l54.56-85.65h-65.28l-51.25,84.09h-16.29c.23-1.14.44-2.28.64-3.44,1.51-7.92,2.27-15.63,2.27-23.13Z"/>
                        <polygon fill="#ffffff" points="110.58 618.25 73.06 618.25 77.29 642.06 110.58 642.06 110.58 733.12 141.88 733.12 141.88 642.06 175.01 642.06 166.56 618.25 141.88 618.25 110.58 618.25"/>
                        <path fill="#ffffff" d="M270.31,687.42c-2.05-2.5-4.27-4.3-6.66-5.41-2.39-1.11-4.63-1.77-6.74-2v-1c5.77-.67,10.32-2.25,13.65-4.75,3.33-2.5,5.69-5.74,7.08-9.74,1.39-4,2.08-8.43,2.08-13.32,0-8.99-1.58-15.95-4.75-20.89-3.16-4.94-8.13-8.46-14.9-10.57-6.77-2.11-15.54-3.16-26.3-3.16-7.22,0-13.4.03-18.56.08-5.16.05-9.91.19-14.23.42-4.33.22-8.93.61-13.82,1.17v114.87h30.63v-43.43c4.19.02,8.98.07,14.48.15,3.22,0,5.66.58,7.32,1.75,1.67,1.16,2.89,3.52,3.66,7.08l8.16,34.46h32.79l-9.49-35.46c-.89-4.33-2.36-7.74-4.41-10.24ZM246.92,661.78c-.89,2.05-2.41,3.47-4.58,4.24-2.17.78-5.25,1.16-9.24,1.16h-15.32v-27.92c4.68-.03,9.78-.04,15.32-.04,3.99,0,7.07.39,9.24,1.16,2.16.78,3.69,2.16,4.58,4.16.88,2,1.33,4.88,1.33,8.66s-.44,6.52-1.33,8.57Z"/>
                        <path fill="#ffffff" d="M364.37,620.41c-1.94-1.44-4.19-2.16-6.74-2.16h-28.8c-2.56,0-4.8.72-6.74,2.16-1.94,1.44-3.25,3.44-3.91,5.99l-31.46,106.71h31.96l6.94-27.3h35.23l6.94,27.3h31.96l-31.46-106.71c-.67-2.55-1.97-4.55-3.91-5.99ZM331.33,683.34l7.49-29.47c.44-1.88.86-3.91,1.25-6.07.39-2.17.69-4.19.92-6.08h4.49c.33,1.89.67,3.91,1,6.08.33,2.16.72,4.19,1.17,6.07l7.49,29.47h-23.8Z"/>
                        <path fill="#ffffff" d="M481.98,673.35c0,3.33.11,6.66.33,9.99.22,3.33.5,6.72.83,10.15h-1.5c-1.33-3.55-2.72-6.93-4.16-10.15-1.44-3.22-2.94-6.16-4.49-8.82l-26.97-47.11c-1.78-3-3.44-5.27-4.99-6.83-1.56-1.55-4-2.33-7.32-2.33h-13.82c-7.32,0-10.99,3.66-10.99,10.99v103.88h29.13v-57.1c0-3.11-.14-6.35-.42-9.74-.28-3.39-.64-6.69-1.08-9.91h1.5c.89,3.22,2,6.44,3.33,9.66,1.33,3.22,2.66,6.22,3.99,8.99l28.14,48.94c1.66,3,3.3,5.27,4.91,6.83,1.61,1.56,4.08,2.33,7.41,2.33h13.98c7.21,0,10.82-3.66,10.82-10.99v-103.88h-28.8l.17,55.1Z"/>
                        <path fill="#ffffff" d="M590.02,666.69l-21.48-7.99c-4.11-1.44-6.96-2.86-8.57-4.24-1.61-1.39-2.41-3.41-2.41-6.08,0-1.67.22-2.97.67-3.91.44-.94,1.19-1.66,2.25-2.16,1.05-.5,2.44-.83,4.16-1,1.72-.17,3.86-.25,6.41-.25,6.77,0,13.68.06,20.73.16,7.05.11,13.01.23,17.9.33l2-20.31c-6.66-2.11-13.54-3.5-20.64-4.16-7.1-.67-13.6-1.05-19.48-1.16-8.1,0-15.04.53-20.81,1.58-5.77,1.06-10.4,2.8-13.9,5.24-3.5,2.44-6.08,5.77-7.74,9.99-1.67,4.22-2.5,9.65-2.5,16.31,0,8.44,1.89,15.26,5.66,20.48,3.77,5.22,10.21,9.71,19.31,13.49l22.97,9.15c2.33.78,4.19,1.56,5.58,2.33,1.39.78,2.36,1.72,2.91,2.83.56,1.11.83,2.61.83,4.49,0,2-.39,3.53-1.17,4.58-.78,1.06-2.17,1.78-4.16,2.16-2,.39-4.89.58-8.66.58-2.22,0-5.24-.02-9.07-.08-3.83-.06-8.32-.17-13.48-.33-5.16-.17-11.07-.3-17.73-.42l-1.83,21.97c9.43,2.33,17.9,3.77,25.39,4.33,7.49.55,13.18.83,17.06.83,8.43,0,15.51-.61,21.22-1.83,5.71-1.22,10.32-3.11,13.82-5.66,3.5-2.55,6.02-6.05,7.57-10.49,1.55-4.44,2.33-9.88,2.33-16.32,0-8.54-1.86-15.51-5.58-20.89-3.72-5.38-10.24-9.9-19.56-13.57Z"/>
                        <path fill="#ffffff" d="M703.89,620c-6.55-2.27-15.59-3.41-27.14-3.41-7.22,0-13.38.03-18.48.08-5.11.05-9.82.19-14.15.42-4.33.22-8.93.61-13.82,1.17v114.87h31.3v-41.11c1.2.14,2.34.29,3.58.41,5.27.5,10.57.75,15.9.75,10.1,0,18.14-1.11,24.14-3.33,5.99-2.22,10.29-6.08,12.9-11.57,2.61-5.49,3.91-13.23,3.91-23.22s-1.39-17.76-4.16-23.31c-2.77-5.55-7.44-9.46-13.98-11.74ZM689.49,664.61c-.83,2.28-2.3,3.83-4.41,4.66-2.11.83-5.11,1.31-8.99,1.42h-14.48v-31.43c4.47-.03,9.29-.04,14.48-.04,3.88,0,6.88.42,8.99,1.25,2.11.83,3.58,2.41,4.41,4.74.83,2.33,1.25,5.61,1.25,9.82s-.42,7.3-1.25,9.57Z"/>
                        <path fill="#ffffff" d="M823.92,628.32c-4.11-4.49-9.43-7.68-15.98-9.57-6.55-1.89-14.59-2.83-24.14-2.83s-17.45.94-24.06,2.83c-6.6,1.89-11.96,5.08-16.07,9.57-4.11,4.5-7.05,10.57-8.82,18.23-1.78,7.66-2.66,17.37-2.66,29.14s.89,21.34,2.66,29.05c1.77,7.72,4.71,13.82,8.82,18.31,4.1,4.49,9.46,7.68,16.07,9.57,6.6,1.89,14.62,2.83,24.06,2.83s17.59-.94,24.14-2.83c6.55-1.89,11.87-5.08,15.98-9.57,4.1-4.5,7.05-10.6,8.82-18.31,1.77-7.71,2.66-17.4,2.66-29.05s-.89-21.48-2.66-29.14c-1.78-7.66-4.72-13.73-8.82-18.23ZM800.86,697.82c-1.06,5.22-2.94,8.82-5.66,10.82-2.72,2-6.52,3-11.4,3s-8.69-1-11.4-3c-2.72-2-4.64-5.6-5.74-10.82-1.11-5.22-1.67-12.6-1.67-22.14s.55-16.92,1.67-22.14c1.11-5.21,3.02-8.82,5.74-10.82,2.72-2,6.52-3,11.4-3s8.68,1,11.4,3c2.72,2,4.61,5.61,5.66,10.82,1.05,5.22,1.58,12.6,1.58,22.14s-.53,16.92-1.58,22.14Z"/>
                        <path fill="#ffffff" d="M935.04,687.42c-2.05-2.5-4.27-4.3-6.66-5.41-2.39-1.11-4.63-1.77-6.74-2v-1c5.77-.67,10.32-2.25,13.65-4.75,3.33-2.5,5.69-5.74,7.08-9.74,1.39-4,2.08-8.43,2.08-13.32,0-8.99-1.58-15.95-4.75-20.89-3.16-4.94-8.13-8.46-14.9-10.57-6.77-2.11-15.54-3.16-26.3-3.16-7.22,0-13.4.03-18.56.08-5.16.05-9.91.19-14.23.42-4.33.22-8.93.61-13.82,1.17v114.87h30.63v-43.43c4.19.02,8.98.07,14.48.15,3.22,0,5.66.58,7.32,1.75,1.67,1.16,2.89,3.52,3.66,7.08l8.16,34.46h32.79l-9.49-35.46c-.89-4.33-2.36-7.74-4.41-10.24ZM911.65,661.78c-.89,2.05-2.41,3.47-4.58,4.24-2.17.78-5.25,1.16-9.24,1.16h-15.32v-27.92c4.68-.03,9.78-.04,15.32-.04,3.99,0,7.07.39,9.24,1.16,2.16.78,3.69,2.16,4.58,4.16.88,2,1.33,4.88,1.33,8.66s-.45,6.52-1.33,8.57Z"/>
                        <polygon fill="#ffffff" points="1050.33 618.25 1017.2 618.25 985.9 618.25 952.6 618.25 952.6 642.06 985.9 642.06 985.9 733.12 1017.2 733.12 1017.2 642.06 1050.33 642.06 1050.33 618.25"/>
                        <path fill="#ffffff" d="M1862.15,822.45v-203.11c0-48.7-39.48-88.18-88.18-88.18h-78.74l-77.11-193.51h-385.74s0-86.82,0-86.82c0-66.86-54.39-121.25-121.25-121.25H10l16.53,66.13h1084.6c30.39,0,55.11,24.72,55.11,55.11v633.45h-131.13l16.53,66.13h253.92s7.16-29.15,19.93-57.12c26.11-51.19,75.53-122.5,180.8-122.5,79,0,126.19,39.27,154.24,79.03,14.16,20.05,23.41,40.21,29.07,55.4,6.28,16.85,10.25,45.19,10.25,45.19h166.06c24.35,0,44.09-19.74,44.09-44.09v-83.87h-47.85ZM1232.33,531.16v-141.45h336.69l56.37,141.45h-393.06Z"/>
                    </svg>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold white--text text-h6">
                        WORK TRANSPORT
                    </v-list-item-title>
                    <v-list-item-subtitle class="white--text caption">
                        ERP Transporte
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            
            <v-divider class="my-2"></v-divider>
            
            <!-- Menu de Funcionalidades -->
            <template v-for="(item, index) in itens">
                <div
                    v-if="shouldShowSectionHeader(index)"
                    class="menu-section"
                    :key="`section-${(item.section || 'OUTROS')}-${index}`"
                >
                    {{ (item.section || 'OUTROS') }}
                </div>
                <MenuGroup
                    v-if="item.type === 'group'"
                    :key="`group-${index}`"
                    :icon="item.icon"
                    :title="item.title"
                    :sub-items="getAuthorizedSubItems(item.subItems)"
                />
                <MenuItem
                    v-else
                    :key="`item-${item.routeName || index}`"
                    :icon="item.icon"
                    :title="item.title"
                    :route-name="item.routeName"
                    :url="item.url"
                />
            </template>
        </v-list>
        
        <!-- Footer com Redes Sociais -->
        <template v-slot:append>
            <div class="social-footer" v-show="!miniVariant">
                <v-divider class="mb-3"></v-divider>
                <div class="social-icons">
                    <v-btn
                        icon
                        small
                        class="social-btn"
                        @click="openSocialLink('https://www.instagram.com/work.innovation/')"
                        title="Instagram"
                    >
                        <v-icon color="white" size="20">mdi-instagram</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        small
                        class="social-btn"
                        @click="openSocialLink('https://wa.me/5598985954728')"
                        title="WhatsApp - Iniciar Conversa"
                    >
                        <v-icon color="white" size="20">mdi-whatsapp</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        small
                        class="social-btn"
                        @click="openSocialLink('https://www.tiktok.com/@workinnovation?_r=1&_t=ZS-919UNLE76sU')"
                        title="TikTok"
                    >
                        <v-icon color="white" size="20">mdi-music-note</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        small
                        class="social-btn"
                        @click="openSocialLink('https://www.youtube.com/@WorkInnovation')"
                        title="YouTube"
                    >
                        <v-icon color="white" size="20">mdi-youtube</v-icon>
                    </v-btn>
                </div>
                <div class="footer-text">
                    <span class="text-caption white--text">Siga-nos nas redes sociais</span>
                </div>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import MenuItem from './MenuItem'
    import MenuGroup from './MenuGroup'
    import { menu } from '../../config'
    import { temAlgumaPermissao } from '../../utils/permissoes'
    import { mapGetters } from 'vuex'
    import store from '../../store'
    import axios from 'axios'

    export default {
        name: 'Menu',
        components: { MenuItem, MenuGroup },
        props: { value: { type: Boolean } },
        computed: {
            ...mapGetters(['username']),
            itens () {
                var menuAutorizado = [];
                var permissoes = store.state.user.permissoes;

                const restrictedDeliveryRouteNames = ['PainelEntregas', 'MonitorEntregas']
                const isAllowedDeliveryUser = () => {
                    const allowedId = '687'
                    const allowedUserLogin = 'fatura100'

                    const storedLogin = localStorage.getItem('userLogin')
                    const storedId = localStorage.getItem('idUsuario') || localStorage.getItem('id')

                    let cachedUserDataId = null
                    try {
                        const cachedUserData = localStorage.getItem('userData')
                        if (cachedUserData) {
                            const parsed = JSON.parse(cachedUserData)
                            cachedUserDataId = parsed && parsed.id != null ? String(parsed.id) : null
                        }
                    } catch (e) {
                        cachedUserDataId = null
                    }

                    return storedLogin === allowedUserLogin || String(storedId) === allowedId || cachedUserDataId === allowedId
                }
                menu.forEach(item=>{
                    if (!temAlgumaPermissao(permissoes, item.permissoes)) return

                    // Itens restritos (entregas)
                    if (item.routeName && restrictedDeliveryRouteNames.includes(item.routeName) && !isAllowedDeliveryUser()) {
                        return
                    }

                    menuAutorizado.push(item)
                })
                return menuAutorizado
            },
            userInfo() {
                return {
                    name: this.userData.username || 'Usuário',
                    role: this.userData.description || 'Usuário'
                };
            },
            miniVariant() {
                // Se localDrawer for false, ativa mini-variant (menu comprimido)
                // Se localDrawer for true, desativa mini-variant (menu expandido)
                return !this.localDrawer;
            }
        },
        data () {
            return {
                localDrawer: this.value !== undefined ? this.value : true,
                userData: {
                    id: null,
                    description: '',
                    username: ''
                }
            }
        },
        async mounted() {
            await this.fetchUserData();
            console.log('Menu mounted, userData:', this.userData);
            
            // Escuta evento global para fechar o menu
            this.$root.$on('fechar-menu', () => {
                this.localDrawer = false;
            });
        },
        beforeDestroy() {
            // Remove listener ao destruir componente
            this.$root.$off('fechar-menu');
        },
        watch: {
            value (val) {
                this.localDrawer = val
            },
            localDrawer (val) {
                this.$emit('input', val)
            }
        },
        methods:{
            async fetchUserData() {
                try {
                    const token = localStorage.getItem('token');
                    if (!token) {
                        console.warn('No token found');
                        return;
                    }

                    const response = await axios.get('https://api.portal.workinnovation.com.br/user', {
                        headers: {
                            'accept': 'application/json, text/plain, */*',
                            'authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });

                    if (response.data) {
                        console.log('User data from API:', response.data);
                        
                        this.userData = {
                            id: response.data.id,
                            description: response.data.description,
                            username: response.data.username
                        };
                        
                        // Salvar no localStorage para cache
                        localStorage.setItem('userData', JSON.stringify(this.userData));
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                    
                    // Tentar carregar do cache do localStorage como fallback
                    const cachedData = localStorage.getItem('userData');
                    if (cachedData) {
                        this.userData = JSON.parse(cachedData);
                        console.log('Using cached user data:', this.userData);
                    }
                }
            },
            getAuthorizedSubItems(subItems) {
                if (!subItems) return [];
                var permissoes = store.state.user.permissoes;

                const restrictedDeliveryRouteNames = ['PainelEntregas', 'MonitorEntregas']
                const isAllowedDeliveryUser = () => {
                    const allowedId = '687'
                    const allowedUserLogin = 'fatura100'

                    const storedLogin = localStorage.getItem('userLogin')
                    const storedId = localStorage.getItem('idUsuario') || localStorage.getItem('id')

                    let cachedUserDataId = null
                    try {
                        const cachedUserData = localStorage.getItem('userData')
                        if (cachedUserData) {
                            const parsed = JSON.parse(cachedUserData)
                            cachedUserDataId = parsed && parsed.id != null ? String(parsed.id) : null
                        }
                    } catch (e) {
                        cachedUserDataId = null
                    }

                    return storedLogin === allowedUserLogin || String(storedId) === allowedId || cachedUserDataId === allowedId
                }

                return subItems.filter(subItem => {
                    if (!temAlgumaPermissao(permissoes, subItem.permissoes)) return false

                    if (subItem.routeName && restrictedDeliveryRouteNames.includes(subItem.routeName) && !isAllowedDeliveryUser()) {
                        return false
                    }

                    return true
                });
            },
            shouldShowSectionHeader(index) {
                if (!this.itens || !this.itens.length) return false;
                const current = this.itens[index];
                const prev = index > 0 ? this.itens[index - 1] : null;
                const currentSection = (current.section || 'OUTROS').toUpperCase();
                const prevSection = prev ? (prev.section || 'OUTROS').toUpperCase() : null;
                return index === 0 || currentSection !== prevSection;
            },
            logout() {
                // Limpar dados do localStorage
                localStorage.removeItem('token');
                localStorage.removeItem('tokenExpiration');
                localStorage.removeItem('sessaoUltimaAtividade');
                localStorage.removeItem('sessaoInicio');
                localStorage.removeItem('user');
                localStorage.removeItem('userData');
                localStorage.removeItem('permissoes');
                localStorage.removeItem('id');
                
                // Limpar controle de modais para próximo login
                sessionStorage.removeItem('modais_exibidos');
                
                // Atualizar estado do Vuex
                this.$store.commit('setIsLoggedIn', false);
                this.$store.commit('setUser', null);
                
                // Redirecionar para login
                this.$router.push('/login');
            },
            openSocialLink(url) {
                window.open(url, '_blank');
            }
        }
    }
</script>

<style scoped>
    .menu-lateral {
        z-index: 1000 !important;
        background-color: #1d4ed8 !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        height: 100vh !important;
        max-height: 100vh !important;
        overflow-y: auto !important;
        /*color: #293846;*/
    }

    /* Responsividade para diferentes tamanhos de tela */
    @media (min-width: 769px) {
        .menu-lateral.v-navigation-drawer--mini-variant {
            width: 80px !important;
            min-width: 80px !important;
            max-width: 80px !important;
        }
        
        .menu-lateral:not(.v-navigation-drawer--mini-variant) {
            width: 320px !important;
            min-width: 320px !important;
            max-width: 320px !important;
        }
    }

    @media (max-width: 768px) {
        .menu-lateral {
            width: 85vw !important;
            min-width: 280px !important;
            max-width: 350px !important;
        }
    }

    @media (max-width: 480px) {
        .menu-lateral {
            width: 90vw !important;
            min-width: 260px !important;
            max-width: 320px !important;
        }
    }

    @media (max-width: 360px) {
        .menu-lateral {
            width: 95vw !important;
            min-width: 240px !important;
            max-width: 300px !important;
        }
    }

    /* Força alinhamento à esquerda para todos os itens do menu */
    .menu-lateral .v-list-item__title {
        text-align: left !important;
        justify-content: flex-start !important;
    }

    .menu-lateral .v-list-item__content {
        text-align: left !important;
        align-items: flex-start !important;
    }

    .menu-lateral .v-list-item {
        justify-content: flex-start !important;
        padding-left: 12px !important;
    }

    /* Adiciona espaçamento entre ícone e texto */
    .menu-lateral .v-list-item__icon {
        margin-right: 8px !important;
    }
    
    .menu-lateral .v-list-group__header .v-list-item__icon {
        margin-right: 8px !important;
    }

    /* Espaçamento específico para itens principais */
    .menu-lateral > .v-list > .v-list-item .v-list-item__icon {
        margin-right: 12px !important;
    }

    /* Espaçamento para títulos dos itens principais */
    .menu-lateral > .v-list > .v-list-item .v-list-item__title,
    .menu-lateral > .v-list > .v-list-group .v-list-group__header .v-list-item__title {
        margin-left: 0 !important;
        padding-left: 0 !important;
    }

    .menu-lateral .v-list {
        padding: 0;
    }

    .menu-lateral .v-list-item--active {
        color: white !important;
    }

    /* Forçar largura do drawer responsiva */
    .menu-lateral .v-navigation-drawer__content {
        width: 100% !important;
        height: 100vh !important;
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch !important;
    }

    /* Estilos para a seção de branding da empresa */
    .company-branding {
        margin: 0;
        padding: 0 !important;
        background: transparent;
        border: none;
        border-radius: 0;
    }

    .company-branding:hover {
        background: transparent;
    }

    .company-branding .v-list-item__avatar {
        margin-right: 16px !important;
    }

    .menu-section {
        color: rgba(255, 255, 255, 0.75);
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.08em;
        padding: 12px 16px 6px 16px;
        text-transform: uppercase;
        text-align: left !important;
        display: block;
    }

    /* Estilos para a seção do perfil do usuário */
    .user-profile-section {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
        margin: 8px 12px 16px 12px;
        border-radius: 12px;
        padding: 16px 12px !important;
        border: 1px solid rgba(255, 255, 255, 0.2);
    }

    .user-profile-section:hover {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08));
    }

    .user-profile-section .v-list-item__avatar {
        margin-right: 16px !important;
    }

    .user-profile-section .v-avatar {
        border: 2px solid rgba(255, 255, 255, 0.3);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .user-profile-section .v-list-item__content {
        margin-right: 8px !important;
    }

    .user-profile-section .v-list-item__action {
        margin: 0 !important;
        min-width: auto !important;
    }

    /* Estilos para o footer das redes sociais */
    .social-footer {
        padding: 16px 20px 20px 20px;
        text-align: center;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02));
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .social-icons {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin-bottom: 12px;
    }

    .social-btn {
        background: rgba(255, 255, 255, 0.1) !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        transition: all 0.3s ease !important;
    }

    .social-btn:hover {
        background: rgba(255, 255, 255, 0.2) !important;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .footer-text {
        opacity: 1;
        font-size: 0.75rem;
        color: white !important;
    }

    .footer-text .text-caption {
        line-height: 1.2;
        color: white !important;
    }

    /* Correções específicas para mobile e tablets */
    @media (max-width: 768px) {
        .menu-lateral .v-navigation-drawer__content {
            height: 100vh !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
        }
        
        /* Ajustes para seção do perfil em mobile */
        .user-profile-section {
            margin: 8px 8px 16px 8px !important;
            padding: 12px 8px !important;
        }
        
        .user-profile-section .v-list-item__avatar {
            margin-right: 12px !important;
        }
        
        .user-profile-section .v-avatar {
            width: 40px !important;
            height: 40px !important;
        }
        
        /* Ajustes para footer social em mobile */
        .social-footer {
            padding: 12px 16px 16px 16px !important;
        }
        
        .social-icons {
            gap: 6px !important;
        }
        
        .social-btn {
            width: 36px !important;
            height: 36px !important;
        }
        
        /* Força alinhamento dos itens do menu em mobile */
        .menu-lateral .v-list-item {
            padding-left: 12px !important;
            padding-right: 12px !important;
        }
        
        .menu-lateral .v-list-item__icon {
            margin-right: 8px !important;
        }
    }
    
    /* Ajustes específicos para telas muito pequenas */
    @media (max-width: 480px) {
        .user-profile-section .v-list-item__content .v-list-item__title {
            font-size: 0.9rem !important;
        }
        
        .user-profile-section .v-list-item__content .v-list-item__subtitle {
            font-size: 0.75rem !important;
        }
        
        .footer-text {
            font-size: 0.7rem !important;
        }
        
        .social-btn {
            width: 32px !important;
            height: 32px !important;
        }
        
        .social-btn .v-icon {
            font-size: 16px !important;
        }
    }
    
    /* Overlay para mobile com z-index correto */
    @media (max-width: 768px) {
        .v-overlay {
            z-index: 999 !important;
        }
        
        .v-overlay--active {
            background-color: rgba(0, 0, 0, 0.5) !important;
        }
    }
</style>
